import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationStart, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { environment } from '../environments/environment';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const scripts: any;

@Component({
  selector: 'xbaht-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();

  constructor(private title: Title, private router: Router) {
    if (!environment.production) {
      this.title.setTitle(
        `${this.title.getTitle()} (v${environment.version} [${
          environment.mode
        }])`
      );
    }
  }

  ngOnInit(): void {
    scripts.initLayout();

    setTimeout(() => {
      scripts.initLayout();
    }, 300);

    // Bootstrap modal sets body.overflow:hidden when opened. If router.navigate() fires
    // before modal.hide() completes, _hideModal crashes on the destroyed element and
    // body.overflow is never cleared — page scroll locks until browser refresh.
    // This cleans up leftover Bootstrap modal state on every SPA navigation.
    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationStart),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        document.body.style.overflow = '';
        document.body.classList.remove('modal-open');
        document
          .querySelectorAll('.modal-backdrop')
          .forEach((el) => el.remove());
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
